import { GAME_COLLECTION_TAG_PATHS } from '@suntex.fim/framework';

import { NodeModel } from '../../../types';

import { modulesNode } from './modules';

export const topGamesNode: NodeModel = {
  tag: GAME_COLLECTION_TAG_PATHS.topGames,
  alias: ['topten'],
  info: {
    title: 'Top Games',
    summary: 'the most popular First In Math® games',
  },
  label: 'Top Games',
  color: 0xbb00ff,
  filterTagPath: GAME_COLLECTION_TAG_PATHS.topGames,
  filterRoot: modulesNode,
};
